import { Dialog as ChadcnDialog } from "@/components/chadcn/Dialog";
import { CustomComponentPropsWithRef, useEffect, useState } from "react";

type DialogProps = Omit<CustomComponentPropsWithRef<typeof ChadcnDialog>, "key">;

const Dialog = ({ open = false, children, ...otherProps }: DialogProps) => {
  const [delayedIsOpen, setDelayedIsOpen] = useState(false);

  // This is a small hack to have the modal animate even when it's conditionally rendered
  useEffect(() => {
    requestAnimationFrame(() => setDelayedIsOpen(open));
  }, [open]);

  return (
    <ChadcnDialog open={delayedIsOpen} {...otherProps}>
      {children}
    </ChadcnDialog>
  );
};

export default Dialog;
